<template>
  <div>
    <el-radio-group v-model="type">
      <el-radio-button label="day">日</el-radio-button>
      <el-radio-button label="week">周</el-radio-button>
      <el-radio-button label="month">月</el-radio-button>
    </el-radio-group>
    <el-date-picker
      class="ml10"
      v-model="dateModels[type]"
      v-bind="dateProps">
    </el-date-picker>
    <span class="ml10" v-if="currentData.update_time">更新时间：{{currentData.update_time}}</span>

    <!-- 用户统计 -->
    <pack class="mt10">
      <zt-title>用户统计<app-link class="more fr" to="/dataStatistics/user-list">查看更多</app-link></zt-title>
      <div class="data-box" v-if="currentData.user">
        <div class="data-item ml10" v-for="({ count, diff_count, arrow }, index) in currentData.user" :key="index">
          <p class="data-head">{{ userOrder[index] }}</p>
          <p class="data-num">
            {{ count }}
            <span :class="arrow" v-if="diff_count">{{ diff_count }}</span>
          </p>
        </div>
      </div>
    </pack>

    <!-- 充值统计 -->
    <pack class="mt10">
      <zt-title>充值统计<app-link class="more fr" to="/dataStatistics/recharge">查看更多</app-link></zt-title>
      <template v-if="currentData.recharge">
        <div class="data-box" v-for="(item, index) in [currentData.recharge]" :key="index">
          <div class="data-item ml10">
            <p class="data-head text-left">充值金额</p>
            <p class="data-num text-left">
              ¥{{ item.amount }}
              <template v-if="item.diff_amount">
                <span class="tips">{{ diffMap[type] }}</span>
                <span :class="item.amount_arrow">¥{{ item.diff_amount }}</span>
              </template>
            </p>
          </div>
          <div class="data-item ml10">
            <p class="data-head text-left">充值笔数</p>
            <p class="data-num text-left">
              {{ item.count }}
              <template v-if="item.diff_count">
                <span class="tips">{{ diffMap[type] }}</span>
                <span :class="item.count_arrow">{{ item.diff_count }}</span>
              </template>
            </p>
          </div>
        </div>
      </template>
    </pack>

    <!-- 消费统计 -->
    <pack class="mt10">
      <zt-title>消费统计<app-link class="more fr" to="/dataStatistics/consumption-list">查看更多</app-link></zt-title>
      <template v-if="currentData.consumption">
        <div class="data-box" v-for="(item, index) in currentData.consumption" :key="index">

          <div class="data-item ml10">
            <p class="data-head text-left">{{ consumptionOrder[index] }}</p>
            <p class="data-num text-left">
              ¥{{ item.amount }}
              <template v-if="item.diff_amount">
                <span class="tips">{{ diffMap[type] }}</span>
                <span :class="item.amount_arrow">¥{{ item.diff_amount }}</span>
              </template>
            </p>
          </div>

          <div class="data-item ml10">
            <p class="data-head text-left">支付笔数</p>
            <p class="data-num text-left">
              {{ item.count }}
              <template v-if="item.diff_count">
                <span class="tips">{{ diffMap[type] }}</span>
                <span :class="item.count_arrow">{{ item.diff_count }}</span>
              </template>
            </p>
          </div>
        </div>
      </template>
    </pack>

    <!-- 产品统计 -->
    <pack class="mt10">
      <zt-title>产品统计</zt-title>
      <el-tabs type="card">
        <el-tab-pane label="cms">
          <template v-if="currentData.productCms">
            <el-table class="table" size="medium" :data="currentData.productCms">
              <el-table-column prop="name" label="产品名称" />
              <el-table-column label="金额(含赠金)">
                <template slot-scope="{row}">
                  <div>
                    ¥{{ row.amount }}
                    <template v-if="row.diff_amount">
                      <span class="tips">{{ diffMap[type] }}</span>
                      <span :class="row.amount_arrow">¥{{ row.diff_amount }}</span>
                    </template>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="笔数">
                <template slot-scope="{row}">
                  <div>
                    {{ row.count }}
                    <template v-if="row.diff_count">
                      <span class="tips">{{ diffMap[type] }}</span>
                      <span :class="row.count_arrow">{{ row.diff_count }}</span>
                    </template>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-tab-pane>
        <el-tab-pane label="插件">
          <template v-if="currentData.productPlugin">
            <el-table class="table" size="medium" :data="currentData.productPlugin">
              <el-table-column prop="name" label="产品名称" />
              <el-table-column label="金额(含赠金)">
                <template slot-scope="{row}">
                  <div>
                    ¥{{ row.amount }}
                    <template v-if="row.diff_amount">
                      <span class="tips">{{ diffMap[type] }}</span>
                      <span :class="row.amount_arrow">¥{{ row.diff_amount }}</span>
                    </template>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="笔数">
                <template slot-scope="{row}">
                  <div>
                    {{ row.count }}
                    <template v-if="row.diff_count">
                      <span class="tips">{{ diffMap[type] }}</span>
                      <span :class="row.count_arrow">{{ row.diff_count }}</span>
                    </template>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-tab-pane>
      </el-tabs>
    </pack>
  </div>
</template>

<script>
import dayjs from 'dayjs'

import admin_data_rpt from '@/api/admin_data_rpt'
export default {
  name: 'AdminIndex',
  data: () => ({

    dateModels: {
      'day': [ new Date(), new Date() ],
      'week': new Date(),
      'month': new Date(),
    },

    type: 'day',

    // 三种纬度的数据缓存
    day: null,
    week: null,
    month: null,

    userOrder: ['新增用户', '活跃用户', '有效授权用户', '总用户'],  // 用户统计排序
    consumptionOrder: ['余额支付', '赠金支付'], // 消费统计排序
    productCmsOrder: ['导购版', '用户中心版', '返利代理版', '尊享版'], // cms产品统计排序

    diffMap: {
      'day': '比前一天',
      'week': '比前一周',
      'month': '比前一个月',
    },

    loading: false,
  }),

  computed: {
    // 当前选择的数据
    currentData: (vm) => vm[vm.type] || {},

    date: (vm) => {
      return vm.dateModels[vm.type]
    },

    dateProps: (vm) => {

      // 公用props
      const comProps = {
        placeholder: '选择日期',
        clearable: false,
      }

      // props
      const privatePropsFn = {
        'day': () => {
          return {
            type: 'daterange',
            pickerOptions: {
              disabledDate: (time) => {
                const now = new Date()
                return dayjs(time).isAfter(now, 'date')
              },
            },
          }
        },
        'week': () => {
          return {
            type: 'week',
            format: (() => {
              const date = new Date(vm.date)
              if(date.toString() !== 'Invalid Date') {
                const begin = date.setDate(date.getDate() - date.getDay() + 1)
                const end = date.setDate(date.getDate() + 6)
                return dayjs(begin).format('YYYY-MM-DD') + ' - ' + dayjs(end).format('YYYY-MM-DD')
              }
            })(),
            pickerOptions: {
              disabledDate: (time) => {
                const now = new Date()
                const isAfter = dayjs(time).isAfter(now, 'date') // time是否大于今天
                const nowWeek = vm.getWeekEndDay(now)
                const nextWeek = vm.getWeekEndDay(time)
                if (isAfter && nextWeek > nowWeek) {
                  return true
                }
              },
              firstDayOfWeek: 1,
            },
          }
        },
        'month': () => {
          return {
            type: 'month',
            format: 'yyyy-MM',
            pickerOptions: {
              disabledDate: (time) => {
                const now = new Date()
                return dayjs(time).isAfter(now, 'date')
              },
            },
          }
        },
      }

      return {
        ...comProps,
        ...privatePropsFn[vm.type](),
      }
    },

  },

  watch: {
    type: {
      immediate: true,
      handler() {
        this.loadData()
      },
    },

    date: {
      handler() {
        this.day = null
        this.month = null
        this.week = null
        this.loadData()
      },
    },
  },

  methods: {
    async loadData() {
      const { type } = this
      if (!this[type]) {
        this.$nextTick(() => {
          this.loading = true
        })

        const {data} = await admin_data_rpt(type, this.date)
        this[type] = {
          consumption: this.formatConsumptionTJ(data),
          user: this.formatUserTJ(data),
          productCms: this.formatProductCmsTJ(data),
          productPlugin: this.formatProductPluginTJ(data),
          recharge: this.formatRechargeTJ(data),
          update_time: data.params.update_time || '',
        }
        this.loading = false
      }
    },

    // 用户统计
    formatUserTJ(data) {
      const { cur_user_tj, last_user_tj } = data

      const result = this.userOrder.map((key) => {
        const count = cur_user_tj[key]
        const last = last_user_tj[key]
        const diff_count = count - last
        return {
          count,
          diff_count: Math.abs(diff_count),
          arrow: diff_count > 0 ? 'up' : 'down',
        }
      })
      return result
    },

    // 充值统计
    formatRechargeTJ(data) {
      const { cur_recharge_tj, last_recharge_tj } = data
      const { amount, count } = cur_recharge_tj
      const last = last_recharge_tj
      const diff_amount = amount - last.amount
      const diff_count = count - last.count

      return {
        amount,
        count,
        diff_amount: Math.abs(diff_amount),
        diff_count: Math.abs(diff_count),
        amount_arrow: diff_amount > 0 ? 'up' : 'down',
        count_arrow: diff_count > 0 ? 'up' : 'down',
      }
    },

    // 消费统计
    formatConsumptionTJ(data) {
      const {cur_consumption_tj, last_consumption_tj } = data
      return this.consumptionOrder.map((key) => {
        const { amount, count } = cur_consumption_tj[key]
        const last = last_consumption_tj[key]
        const diff_amount = amount - last.amount
        const diff_count = count - last.count

        return {
          amount,
          count,
          diff_amount: Math.abs(diff_amount),
          diff_count: Math.abs(diff_count),
          amount_arrow: diff_amount > 0 ? 'up' : 'down',
          count_arrow: diff_count > 0 ? 'up' : 'down',
        }
      })
    },

    // cms产品统计
    formatProductCmsTJ(data) {
      const { last_production_cms_tj, cur_production_cms_tj } = data

      return this.productCmsOrder.map((key, index) => {
        const { amount, count } = cur_production_cms_tj[key]
        const last = last_production_cms_tj[key]

        const diff_amount = amount - last.amount
        const diff_count = count - last.count
        return {
          name: this.productCmsOrder[index],
          amount,
          count,
          diff_amount: Math.abs(diff_amount),
          diff_count: Math.abs(diff_count),
          amount_arrow: diff_amount > 0 ? 'up' : 'down',
          count_arrow: diff_count > 0 ? 'up' : 'down',
        }
      })
    },

    // 插件产品统计
    formatProductPluginTJ(data) {
      const { cur_production_plug_tj, last_production_plug_tj } = data

      return Object.entries(cur_production_plug_tj).map(([key, { amount, count }]) => {
        const last = last_production_plug_tj[key]

        const diff_amount = amount - last.amount
        const diff_count = count - last.count

        return {
          name: key,
          amount,
          count,
          diff_amount: Math.abs(diff_amount),
          diff_count: Math.abs(diff_count),
          amount_arrow: diff_amount > 0 ? 'up' : 'down',
          count_arrow: diff_count > 0 ? 'up' : 'down',
        }
      }).sort((a, b) => {
        return b.amount - a.amount
      })
    },


    isNextWeek(date) {
      const d = this.getWeekEndDay(date)
      d.setDate(d.getDate() + 1)
    },

    getWeekEndDay(date) {
      if (date.constructor.name !== 'Date') {
        date = new Date(date)
      }
      const day = date.getDay() === 0 ? 7 : date.getDay() // 周几 1-7
      const diff = 7 - day
      if (diff > 0) {
        date.setDate(date.getDate() + diff)
      }
      return date
    },
  },

};
</script>

<style lang="scss" scoped>
@import "~@/styles/table.scss";
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #f7f2ff;
}
/deep/ .el-picker-panel {
  position: absolute;
  z-index: 1;
}
.table {
  text-align: center;
  font-size: 16px !important;
}
.more {
  color: $theme;
  font-size: 14px;
}
.data-box {
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-top: 10px;
  .data-item {
    flex: 1;
    // text-align: center;
    font-size: 16px;
    .data-head {
      font-weight: 600;
      margin-bottom: 10px;
    }
    .data-num {
      font-size: 16px;
    }
  }
}
.tips {
  font-size: 12px;
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;
  color: $gray;
}
.up {
  font-size: 12px;
  color: $theme-gold;
  &::after {
    content: "↑";
    display: inline-block;
    margin-left: 2px;
    vertical-align: 2px;
  }
}
.down {
  font-size: 12px;
  color: $theme-green;
  &::after {
    content: "↓";
    display: inline-block;
    margin-left: 2px;
    vertical-align: 2px;
  }
}

/deep/.pack {
  // padding: 24px;
  padding-top: 16px;
  padding-bottom: 16px;
  margin-bottom: 10px;
}
</style>



